query TravelerAvailableDocumentTypes {
  travelerAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
    }
  }
}
